<script lang="ts" setup>
import { computed } from "vue";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";

const props = defineProps({
  filterCount: {
    type: Number,
    default: 0
  }
});

const isFilterApplied = computed(() => {
  return props.filterCount > 0;
});

const btnClass = computed(() => {
  if (isFilterApplied.value) {
    return "filter-button--applied";
  }
  return "";
});

const emits = defineEmits(["click-filter"]);

function onClickFilter() {
  emits("click-filter");
}
</script>

<template>
  <div class="d-inline-block">
    <div
      class="filter-button"
      data-testid="filter-button"
      :class="btnClass"
      @click="onClickFilter"
    >
      <div class="filter-phrase" data-testid="filter-phrase">
        <FeatherIcon icon="filter" />
        {{ isFilterApplied ? "絞り込み中" : "絞り込み" }}
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.filter-button {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 500;
  color: #31373f;

  .filter-phrase {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 24px;
  }

  &--applied svg {
    fill: $mild;
  }

  svg {
    width: 24px;
    height: 24px;
    margin-right: 4px;
    color: $mild;
  }
}
</style>
